import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { WARM_UP_MESSAGE } from "../App";
import { ColorPalette } from "../utils/constants";
import { borderRadius } from "../utils/designSystem";

const SLOW_LOAD_MESSAGE_DELAY_MS = 5000;

type Props = { message?: string };

export const CustomSpinner = ({ message }: Props) => {
  const [showSlowLoadMessage, setShowSlowLoadMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSlowLoadMessage(true);
    }, SLOW_LOAD_MESSAGE_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  const displayMessage = message ?? (showSlowLoadMessage ? WARM_UP_MESSAGE : undefined);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        p: 4,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 6,
          borderRadius: borderRadius.lg,
          border: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
          textAlign: "center",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        {displayMessage && (
          <Typography
            variant="h6"
            sx={{
              mb: 4,
              color: "text.secondary",
              fontWeight: 500,
            }}
          >
            {displayMessage}
          </Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <CircularProgress
            sx={{
              color: ColorPalette.blue,
            }}
          />
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
          Loading...
        </Typography>
      </Paper>
    </Box>
  );
};
